<script context="module" lang="ts">
  declare var TableReadonly: any;
</script>

<script lang="ts">
  import { getContext, onMount } from 'svelte';
  import route from '../Util/routes';
  
  export let workout_id;
  
  let url = route("WorkoutController@getIntervals", [workout_id]);
  onMount(()=>{
    TableReadonly.init(url);
  });
</script>


<div class="data-table"> 
  <table class="table table-striped table-hover table-bordered dt-responsive" id="workout_sets" width="100%" style="margin: 20px 0 !important;">
    <thead>
      <tr>
        <th></th>
        <th  class="col-md-2">
          Name
        </th>
        <th class="col-md-2" id="interval_power_head">
          Power
        </th>
        <th  class="col-md-2" id="interval_duration_head">
          Duration
        </th>
        <th  class="col-md-2"  id="rest_between_power_head">
          Rest-in-between Power
        </th>
        <th   class="col-md-2" id="rest_between_duration">
          Rest-in-between Duration
        </th>
        <th id="interval_count">
          Interval Count
        </th>
      </tr>
    </thead>
    <tbody >
    </tbody>
  </table>
</div>

<style lang="scss">
  .data-table {
    margin-bottom: 64px;
  }
</style>